module.exports = {
	"id": "AL",
	"name": "Albania",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": 0.009394,
			"6": null,
			"7": null,
			"8": null,
			"9": 0.004697,
			"10": 0.009394,
			"11": 0.028182,
			"12": 0.009394,
			"13": null,
			"14": 0.004697,
			"15": null,
			"16": 0.004697,
			"17": null,
			"18": 0.018788,
			"19": null,
			"20": null,
			"21": null,
			"22": 0.042273,
			"23": 0.004697,
			"24": null,
			"25": 0.004697,
			"26": 0.014091,
			"27": 0.014091,
			"28": 0.018788,
			"29": 0.028182,
			"30": 0.018788,
			"31": 0.018788,
			"32": 0.009394,
			"33": 0.037576,
			"34": 0.037576,
			"35": 0.018788,
			"36": 0.023485,
			"37": 0.023485,
			"38": 0.023485,
			"39": 0.09394,
			"40": 0.051667,
			"41": 0.032879,
			"42": 0.018788,
			"43": 0.216062,
			"44": 0.075152,
			"45": 0.042273,
			"46": 0.089243,
			"47": 0.150304,
			"48": 0.103334,
			"49": 4.748667,
			"50": 0.239547,
			"51": 1.193038,
			"52": 0.310002,
			"53": 21.333774,
			"54": 6.007463,
			"55": 0.084546,
			"56": 0.018788,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.042273,
			"4": 0.009394,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": 0.014091,
			"11": 0.009394,
			"12": null,
			"13": null,
			"14": 0.018788,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": 0.004697,
			"21": null,
			"22": 0.009394,
			"23": null,
			"24": 0.028182,
			"25": null,
			"26": null,
			"27": 0.004697,
			"28": 0.004697,
			"29": 0.009394,
			"30": 0.014091,
			"31": 0.014091,
			"32": 0.023485,
			"33": 0.018788,
			"34": 0.014091,
			"35": 0.014091,
			"36": 0.084546,
			"37": 0.018788,
			"38": 0.056364,
			"39": 0.028182,
			"40": 0.037576,
			"41": 0.04697,
			"42": 0.023485,
			"43": 0.18788,
			"44": 0.070455,
			"45": 0.112728,
			"46": 0.131516,
			"47": 0.620004,
			"48": 0.333487,
			"49": 3.358355,
			"50": 0.084546,
			"51": 0.004697,
			"52": null,
			"3.5": null,
			"3.6": 0.018788
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": 0.009394,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": 0.051667,
			"37": 0.028182,
			"38": 0.18788,
			"39": 0.009394,
			"40": 0.347578,
			"41": 0.061061,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.014091
		},
		"safari": {
			"0": null,
			"4": 0.004697,
			"5": 0.009394,
			"6": null,
			"7": 0.004697,
			"8": 0.028182,
			"9": 0.037576,
			"10": 0.197274,
			"3.1": null,
			"3.2": null,
			"5.1": 0.018788,
			"6.1": 0.014091,
			"7.1": 0.004697,
			"9.1": 0.136213
		},
		"ios_saf": {
			"8": 0,
			"10": 9.45245669276,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.254732770192,
			"8.1-8.4": 0.470607999167,
			"9.0-9.2": 0.224510238135,
			"9.3": 3.42522029975
		},
		"android": {
			"3": 0,
			"4": 0.118099658915,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.0147624573643,
			"4.1": 0.426002341085,
			"4.2-4.3": 1.06500585271,
			"4.4": 2.44213223256,
			"4.4.3-4.4.4": 2.46322145736
		},
		"ie": {
			"6": 0.019399443787,
			"7": 0.019399443787,
			"8": 0.455886928994,
			"9": 0.111546801775,
			"10": 0.0775977751479,
			"11": 0.950572745562,
			"5.5": null
		},
		"op_mob": {
			"0": 0.110830694707,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.00307863040853
		},
		"edge": {
			"12": 0.028182,
			"13": 0.150304,
			"14": 0.277123
		},
		"ie_mob": {
			"10": 0.236364169014,
			"11": 0.962339830986
		},
		"bb": {
			"7": 0.057018,
			"10": null
		},
		"samsung": {
			"0": 3.346824
		},
		"and_uc": {
			"0": 0.307632
		},
		"op_mini": {
			"0": 1.49320267488
		},
		"and_chr": {
			"0": 27.502684
		},
		"and_ff": {
			"0": 0.02652
		}
	},
	"total": 98.3670131391
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/AL.json
 ** module id = 460
 ** module chunks = 0
 **/